export default {
  title: 'Categorias',
  description: 'Gerencie as categorias do seu blog.',
  labels: {
    new: 'Nova categoria',
  },
  form: {
    title: 'Cadastro de categorias'
  },
  fields: {
    name: 'Categoria',
    language: 'Idioma',
    url: 'URL',
    is_active: 'Ativo'
  },
  errors: {
    duplicateCompositeKey: 'Essa categoria já está cadastrada para este site e idioma.'
  }
}
